import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Button } from 'reactstrap'
import { useSelector, useDispatch } from "react-redux"
import swal from 'sweetalert';
import * as Actions from "../../../../store/actions/"
import moment from "moment"
import Alert from "../../../common/alert";
import Swal from 'sweetalert2';
import Store from "../../meetingScreen/editor/store"
const NewMeetingNavBar = (props) => {


    const dispatch = useDispatch()


    const [NumberOfNewMsg, setNumberOfNewMsg] = useState(0)
    const [People, setPeople] = useState({})
    const [MuteAll, setMuteAll] = useState(false)
    const [useLess, setuseLess] = useState(1)
    const [StarTime, setStart] = useState(new Date())
    const [CurrentTime, setCurrentTime] = useState(new Date())
    const UserData = useSelector(({ auth }) => auth.UserData);
    const VerifyData = useSelector(({ auth }) => auth.VerifyData);
    const baseURL = useSelector(({ utils }) => utils.baseURL);

    const People2 = useSelector(({ meeting }) => meeting.People)
    const isHost = useSelector(({ meeting }) => meeting.IsHost)
    const meetingSession = useSelector(({ meeting }) => meeting.meetingSession)
    const Chat = useSelector(({ meeting }) => meeting.Chat)

    let myTime;
    useEffect(() => {
        clearInterval(myTime)

        if (!props.MeetingEnded) {
            myTime = setInterval(() => {
                setCurrentTime(new Date())
            }, 1000);
        }


        return () => clearInterval(myTime)
    }, [props.MeetingEnded])

    useEffect(() => {
        if (People2) setPeople(People2)
        UseLessFunction()

    }, [People2])

    useEffect(() => {
        if (!props.ChatBoxOpen && Chat.length > 0) {
            setNumberOfNewMsg(NumberOfNewMsg + 1)
        }
        if (props.ChatBoxOpen && Chat.length > 0 && props.SideBarType != "Chat") {
            setNumberOfNewMsg(NumberOfNewMsg + 1)
        }
    }, [Chat])

    useEffect(() => {
        if (props.SideBarType == "Chat") {
            setNumberOfNewMsg(0)
        }
    }, [props.ChatBoxOpen])

    function UseLessFunction() {
        setuseLess(useLess + 1)

        setTimeout(() => {
            UseLessFunction()
        }, 2000);
    }

    const ImagesToMap = useSelector(({ meeting }) => meeting.ScreenShotImages)
    const ScreenShotOpen = useSelector(({ meeting }) => meeting.ScreenShotOpen)



    return (
        <div>
            <nav style={{ backgroundColor: "#2a2a2a" }}>
                <div className="text-white d-md-flex justify-content-between align-items-center px-md-5 container-fluid text-center" >
                    <div className="companyLogo py-3">
                        <img style={{ height: "35px", }} src={VerifyData?.clinicLogo ? VerifyData?.clinicLogo : "/images/ptlogo.png"} />
                    </div>
                    <div className="d-flex justify-content-center" >
                        <div>
                            Meeting ID &nbsp;</div>
                        <div className="link"
                            style={{
                                fontSize: "16px",
                                color: "#2570b7"
                            }}
                        >
                            {window.location.pathname.replace("/room/", "").substring(0, 9)}  &nbsp;
                            <img
                                onClick={async (e) => {
                                    await navigator.clipboard.writeText(`${window.location.origin}${window.location.pathname}`)
                                    Alert(`${window.location.origin}${window.location.pathname}`, 'success', 'Link copied to clipboard.')
                                }}
                                title="Copy"
                                style={{ cursor: "pointer" }} src="/images/icons/copy.svg" />
                        </div>
                    </div>

                    <div>
                        {
                            isHost ? (
                                <span style={{ cursor: "pointer" }}
                                    onClick={async () => {
                                        const MUTE_ALL_UNMUTE_ALL = "MUTE_ALL_UNMUTE_ALL"

                                        if (MuteAll) {
                                            setMuteAll(false)
                                            dispatch(Actions.MuteUnmute(meetingSession?.audioVideo?.realtimeIsLocalAudioMuted()))
                                            meetingSession.audioVideo.realtimeUnmuteLocalAudio();
                                            meetingSession?.audioVideo.realtimeSendDataMessage(MUTE_ALL_UNMUTE_ALL, JSON.stringify({ Mute: false }), 1000000000)

                                        } else {
                                            const Yes = await swal("Are you sure?", "All the participants will get muted! ", "warning")
                                            if (Yes) {
                                                if(!meetingSession?.audioVideo?.realtimeIsLocalAudioMuted()){
                                                    dispatch(Actions.MuteUnmute(meetingSession?.audioVideo?.realtimeIsLocalAudioMuted()))
                                                }
                                                meetingSession.audioVideo.realtimeMuteLocalAudio();

                                                meetingSession?.audioVideo.realtimeSendDataMessage(MUTE_ALL_UNMUTE_ALL, JSON.stringify({ Mute: true }), 1000000000)
                                                setMuteAll(true)
                                            }
                                        }
                                    }}
                                >
                                    {
                                        !MuteAll ? (
                                            <>
                                                <img src="/images/icons/mute.svg" style={{ cursor: "pointer" }} /> &nbsp;
                                                <p className="pr-lg-4 pr-md-1" style={{ fontSize: "16px", cursor: "pointer", display: 'inline-block', borderRight: "#c9c9c9 1px solid" }} >Mute All</p>

                                            </>
                                        ) : (
                                            <>
                                                <img src="/images/volume-2.svg" style={{ cursor: "pointer" }} /> &nbsp;
                                                <p className="pr-lg-4 pr-md-1" style={{ fontSize: "16px", cursor: "pointer", display: 'inline-block', borderRight: "#c9c9c9 1px solid" }} >Allow Unmute</p>

                                            </>
                                        )
                                    }
                                </span>
                            ) : null
                        }

                        <span style={{ cursor: "pointer" }} onClick={async () => {
                            if(props.IsWhiteBoardOpenForNavBar){
                                Alert("", "warning", "Please close the whiteboard before accessing participants!")
                                return 
                            }
                            if (props.Stage !== 1) {
                                const res = await Swal.fire(
                                    {
                                        cancelButtonText: "Cancel",
                                        text: "If you change the tab during measurements, all unsaved data will be lost",
                                        title: "Are you sure you want to change tab?",
                                        confirmButtonText: "Confirm",
                                        showCloseButton: true,
                                        showCancelButton: true,
                                    }
                                )
                                if (!res.value || res.dismiss == "cancel" || res.dismiss == "close") return
                            }
                            props.openChat("Participants")
                        }} >
                            <img title="Participants" className="pl-lg-4 pl-md-1" src="/images/icons/XMLID_10_.svg" style={{ cursor: "pointer" }} /> &nbsp;
                            <p className="pr-lg-4 pr-md-1" style={{ fontSize: "16px", display: 'inline-block', borderRight: "#c9c9c9 1px solid" }} >{Object.keys(People)?.length}</p>

                        </span>
                        <span style={{ position: "relative" }}>
                            <img title="Chat" onClick={async () => {
                                  if(props.IsWhiteBoardOpenForNavBar){
                                    Alert("", "warning", "Please close the whiteboard before accessing message!")
                                    return 
                                }
                                if (props.Stage !== 1) {
                                    const res = await Swal.fire(
                                        {
                                            cancelButtonText: "Cancel",
                                            text: "If you change the tab during measurements, all unsaved data will be lost",
                                            title: "Are you sure you want to change tab?",
                                            confirmButtonText: "Confirm",
                                            showCloseButton: true,
                                            showCancelButton: true,
                                        }
                                    )
                                    if (!res.value || res.dismiss == "cancel" || res.dismiss == "close") return
                                }
                                props.openChat("Chat")
                            }} src="/images/icons/chat69.svg" className="px-lg-4 px-md-1" style={{ borderRight: "#c9c9c9 1px solid", cursor: "pointer" }} />

                            {

                                NumberOfNewMsg > 0 ? <span style={{ position: "absolute" }} className="THE_DOT_69" > {NumberOfNewMsg} </span> : null
                            }
                        </span>
                        <p className="px-4 video-time" style={{ fontSize: "16px", display: 'inline-block' }} >
                            {false ? <span className="pt-1" style={{ fontSize: "12px", color: "#ff5b57" }} >Recording</span> : ""}
                            <br />
                            {moment.utc(moment(CurrentTime, "DD/MM/YYYY HH:mm:ss").diff(moment(StarTime, "DD/MM/YYYY HH:mm:ss"))).format("HH:mm:ss")}</p>
                    </div>
                </div>

            </nav>

        </div>
    )
}

export default NewMeetingNavBar
